import React, { useEffect, useCallback, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import server from "../../../api/server.js";
import { useNavigate } from "react-router-dom";
import { MdArrowBack, MdOutlineDescription } from 'react-icons/md';
import { IoIosCall, IoIosPersonAdd } from "react-icons/io";
import FeedbackSection from "../../layouts/FeedbackSection.jsx"
import { MdOutlineExpandMore } from "react-icons/md";
import { MdOutlineExpandLess } from "react-icons/md";
import { RiMapPinTimeLine, RiSurveyLine } from "react-icons/ri";
import { MdDensitySmall } from "react-icons/md";
import { PiWarningCircle } from "react-icons/pi";
import { FaEye, FaTimes } from "react-icons/fa";
import { IoIosCloseCircleOutline } from "react-icons/io";
import CallDetails from "../calls/CallDetails.jsx";

import { 
    FaLightbulb, 
    FaUser, 
    FaQuestionCircle,
    FaRegFileAlt
  } from "react-icons/fa";
import '../../../dashboard-components/loader.css';
import { IoChatbubbleOutline, IoChatbubbleSharp, IoRefresh, IoFlashOutline, IoPulseOutline } from "react-icons/io5";
import { ChevronsLeft, ChevronsRight, Menu, PencilLine } from "lucide-react";
import { MoreVertical } from 'lucide-react';
import { useToast } from '../../../context/ToastContext.jsx';

const CustomerDetails = ({selectedOption, selectedClientId, customerIdProp, open_type}) => {
    const { showToast } = useToast();
    const { customerId } = useParams();
    const [client_id, setClient_id] = useState(null);
    const [service_id, setService_id] = useState(null)
    const [email, setEmail] = useState(null)
    const [sections, setSections] = useState([])
    const [showMoreMap, setShowMoreMap] = useState({});
    const [expandedSection, setExpandedSection] = useState(0);
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState(null)
    const [showSummary, setShowSummary] = useState({});
    const [selectedCallID, setSelectedCallID] = useState(null)
    const [showConversationPage, setShowConversationPage] = useState(false)
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const tabRowRef = useRef(null);
    const navigate = useNavigate();
    const [selectedSection, setSelectedSection] = useState(null);
    const [selectedSegment, setSelectedSegment] = useState(null);
    const [selectedTab, setSelectedTab] = useState(null);
    const [isRerunPrechecking, setIsRerunPrechecking] = useState(false);
    const [isRerunApplying, setIsRerunApplying] = useState(false);
    const [showRerunConfirm, setShowRerunConfirm] = useState(false);
    const [rerunTotalCost, setRerunTotalCost] = useState(0);
    const [rerunCurrentBalance, setRerunCurrentBalance] = useState(0);
    const [rerunAffectedCount, setRerunAffectedCount] = useState(0);
    const [canProceedRerun, setCanProceedRerun] = useState(false);
    const [pendingRerunConfig, setPendingRerunConfig] = useState(null);
    const [showActionsMenu, setShowActionsMenu] = useState(false);
    const [showTriggerModal, setShowTriggerModal] = useState(false);
    const [selectedTrigger, setSelectedTrigger] = useState(null);
    const [rerunBalanceValid, setRerunBalanceValid] = useState(0);
    // Compute filteredSections once per render
  const filteredSections = sections.filter(section => Array.isArray(section.data) ? section.data.length > 0 : section.data);

  // Ensure selectedSection is always in sync with filteredSections
  useEffect(() => {
    if (filteredSections.length > 0) {
      // If expandedSection is null or out of bounds, default to first
      const idx = (expandedSection != null && expandedSection < filteredSections.length) ? expandedSection : null;
      setSelectedSection(filteredSections[idx]);
    } else {
      setSelectedSection(null);
    }
    // eslint-disable-next-line
  }, [sections, expandedSection]);
    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
    const toggleSummary = (index) => {
        setShowSummary(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };
      const debounce = (func, delay) => {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => func(...args), delay);
        };
      };
      const formatDurationSeconds = (value) => {
        if (value === null || value === undefined || value === '') return 'N/A';
        const normalizedSeconds = Math.floor(Number(value));
        if (!Number.isFinite(normalizedSeconds) || normalizedSeconds < 0) return 'N/A';
        const hours = Math.floor(normalizedSeconds / 3600);
        const minutes = Math.floor((normalizedSeconds % 3600) / 60);
        const seconds = normalizedSeconds % 60;
        return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      };
      const getFirstDefinedValue = (...values) => values.find((value) => value !== null && value !== undefined && value !== '');
      const buildCustomerOverviewData = (customerData, actualCustomerId) => {
        const frt = getFirstDefinedValue(customerData?.frt);
        const frtBusiness = getFirstDefinedValue(
          customerData?.frt_business
        );

        return {
          ...customerData,
          customer_id: actualCustomerId,
          first_response_time: formatDurationSeconds(frt),
          first_response_time_business_hours: formatDurationSeconds(frtBusiness),
        };
      };
      const selectedOptionRef = useRef(selectedOption);
        selectedOptionRef.current = selectedOption;

      const getCustomerDetails = async (hardRefresh = false) => {
        setLoading(true)
        const user = getCookie("dashboard_login_user_creds")
          ? JSON.parse(getCookie("dashboard_login_user_creds"))
          : null;
    
        if (user) {
          let clientId = selectedClientId;
          let email = user.email
          // Decode the customerId if it comes from URL params (it would be encoded)
          const actualCustomerId = customerIdProp ? customerIdProp : (customerId ? decodeURIComponent(customerId) : customerId);
          setClient_id(clientId)
          try {
            let res = await server.getCustomersDetails(clientId, selectedOption, actualCustomerId, email, "customers", undefined, window.location.href, hardRefresh);
            if(res.status === 200){
                let resp = await res.json();
                const overviewData = buildCustomerOverviewData(resp.data, actualCustomerId);
                setData(resp.data);
                setSections([
                  {title: "Overview", dataKey: "customerOverview", data: overviewData},
                  {title: "Customer Summary", dataKey: "Customer Summary", data: resp.data?.customer_summary?.customer_summary_with_source ? {'call_summary_with_source': resp.data?.customer_summary?.customer_summary_with_source} : null},
                  { title: "Lead Quality", dataKey: "Lead Quality", data: resp.data.lead_quality },
                  { title: "Business Insights", dataKey: "Business Insights", data: resp.data?.business_insights },
                  {title: "Open Concerns & Queries", dataKey: "Concern & Queries", data: resp.data?.concerns_and_queries?.ans},
                  {title: "Customer Feedback", dataKey: "Customer Feedback", data: resp.data.customer_feedback?.ans},
                    { title: "Dispositions & Subdispositions", dataKey: "Dispositions", data: resp.data?.conversation_dispositions },
                    {title: "Customer Journey", dataKey: "Customer Journey", data: resp.data.customer_journey},
                    {title: "Custom Module", dataKey: "Custom Module", data: resp.data.custom_module},
                    {title: "Customer Personas", dataKey: "Personas", data: resp.data.customer_persona?.ans}
                  ]);
            }
          } catch (error) {
          }finally{
            setLoading(false);
          }
        }
      };
      const handleHardRefresh = async () => {
        if (loading) return;
        await getCustomerDetails(true);
      }
      const handleGoBack = () => {
        if(customerIdProp){
          open_type();
          return;
        }
        navigate(-1); 
      }
      const gotoCalls = (call_id) => {
        // if(customerIdProp){
          setShowConversationPage(true);
          setSelectedCallID(call_id)
          
        // Properly encode the call_id to handle special characters, spaces, and other URL-unsafe characters
        // const encodedCallId = encodeURIComponent(call_id);
        // navigate(`/${selectedClientId}/${selectedOption}/conversations/${encodedCallId}?service_id=${selectedOption}`)
      }
      const handleClose = () => {
        setShowConversationPage(false)
        setSelectedCallID(null)
      }
      const openTriggerModal = (triggerItem) => {
        setSelectedTrigger(triggerItem);
        setShowTriggerModal(true);
      }
      const closeTriggerModal = () => {
        setSelectedTrigger(null);
        setShowTriggerModal(false);
      }
      useEffect(() => {
        const handleEsc = (event) => {
          if (event.key === 'Escape') {
            setShowTriggerModal(false);
          }
        };
        if (showTriggerModal) {
          window.addEventListener('keydown', handleEsc);
        }
        return () => {
          window.removeEventListener('keydown', handleEsc);
        };
      }, [showTriggerModal]);
      const toggleSection = (index) => {
        setExpandedSection((prev) => (prev === index ? index : index));
      };
      const toggleShowMore = (key) => {
        setShowMoreMap(prev => ({ ...prev, [key]: !prev[key] }));
      };
      function convertEpochToReadable(epoch_time, isMilliseconds = true, location=undefined) {
        let epoch = null
        if(!location){
          if (epoch_time && epoch_time.call_time){
            epoch = epoch_time.call_time
          }else{
            epoch = epoch_time.time
          }
        }else{
          if(location === 'First'){
            epoch = Number(epoch_time[0].time)
          }else if(location === 'Last'){
            epoch = Number(epoch_time[epoch_time.length-1].time)
          }else{
            epoch = undefined
          }
        }
        // Convert to milliseconds if the epoch is in seconds
        const date = new Date(isMilliseconds ? epoch : epoch * 1000);
    
        // Format the date as "YYYY-MM-DD HH:mm:ss"
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }
    const renderIconHere = (title) => {
        switch (title) {
          case "Business Insights":
            return <FaLightbulb style={{ marginRight: "8px" }} />;
          case "Customer Personas":
            return <FaUser style={{ marginRight: "8px" }} />;
          case "Open Concerns & Queries":
            return <PiWarningCircle style={{ marginRight: "5px", fontSize: "19px" }} />;
          case "Customer Feedback":
            return <RiSurveyLine style={{ marginRight: "5px", fontSize: "19px" }} />;
          case "Lead Quality":
            return <IoIosPersonAdd style={{marginRight: "8px"}}/>
          case "Overview":
            return <Menu style={{marginRight: "8px", height: "16px"}}/>
          case "Dispositions & Subdispositions":
            return <PencilLine style={{marginRight: "8px", height: "16px"}}/>
          case "Customer Summary":
            return <MdOutlineDescription style={{marginRight: "5px", fontSize: "19px"}}/>
          case "Custom Module":
            return <FaRegFileAlt style={{marginRight: "8px"}}/>
          default:
            return null; // No icon for unmatched titles
        }
      };
    useEffect(() => {
        // Dynamically build the initial showMoreMap based on `data`
        if (data) {
          const initialShowMoreMap = {};
          initialShowMoreMap[`Customer Summary`] = false;
          data?.custom_module && Array.isArray(data?.custom_module) && data?.custom_module?.forEach((_, idx) => {
            initialShowMoreMap[`Custom Module - ${idx}`] = false;
          });
          data?.open_concerns_and_queries?.ans?.forEach((_, idx) => {
            initialShowMoreMap[`Concern and Queries - ${idx}`] = false;
          });
          data?.customer_persona && data?.customer_persona?.ans?.forEach((_, idx) => {
            initialShowMoreMap[`Personas - ${idx}`] = false;
          });
          data?.business_insights?.forEach((_, idx) => {
            initialShowMoreMap[`Business Insights - ${idx}`] = false;
          });
          data?.customer_feedback?.ans?.forEach((_, idx) => {
            initialShowMoreMap[`Customer Feedback - ${idx}`] = false;
          });
          data?.lead_quality?.forEach((_, idx) => {
            initialShowMoreMap[`Lead Quality - ${idx}`] = true;
          });
          initialShowMoreMap[`Dispositions`] = true;
          setShowMoreMap(initialShowMoreMap);
        }
      }, [data]);
    
    const debouncedGetCustomerDetails = useCallback(debounce(getCustomerDetails, 300), []);
    useEffect(() => {
      if (selectedOption && selectedClientId && email) {
        debouncedGetCustomerDetails();
      }
    }, [selectedOption, customerId, debouncedGetCustomerDetails, customerIdProp, email]);
    useEffect(()=> {
      if(selectedOption){
        setService_id(selectedOption)
      }
      if(selectedClientId){
        setClient_id(selectedClientId)
      }
      const user = getCookie("dashboard_login_user_creds")
        ? JSON.parse(getCookie("dashboard_login_user_creds"))
        : null;
      if(user){
        let email =user.email
        setEmail(email)
      }
    }, [selectedOption, selectedClientId])
    const checkTabRowScroll = () => {
      const el = tabRowRef.current;
      if (!el) return;
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };
  
    useEffect(() => {
      checkTabRowScroll();
      const el = tabRowRef.current;
      if (!el) return;
      el.addEventListener('scroll', checkTabRowScroll);
      window.addEventListener('resize', checkTabRowScroll);
      return () => {
        el.removeEventListener('scroll', checkTabRowScroll);
        window.removeEventListener('resize', checkTabRowScroll);
      };
    }, [filteredSections.length]);
  
    const scrollTabRow = (direction) => {
      const el = tabRowRef.current;
      if (!el) return;
      const scrollAmount = 240; // px
      el.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    };
    const handleSourceClick = (source) => {
      if(source.conversation_id){
        setShowConversationPage(true)
        setSelectedSegment(source)
        setSelectedTab(filteredSections[expandedSection].title)
        setSelectedCallID(source.conversation_id)
      }
    }
    useEffect(() => {
      const handleEsc = (event) => {
        if (event.key === "Escape") {
          setShowConversationPage(false);
        }
      }
      if (showConversationPage) {
        window.addEventListener('keydown', handleEsc);
      }
      return () => {
        window.removeEventListener('keydown', handleEsc);
      }
    }, [showConversationPage])

    const getEnabledModulesList = async () => {
      try {
        let res = await server.defaultModuleStatus(client_id, Array.isArray(service_id) ? service_id[0] : service_id, email, 'apps', undefined);
        if (res.status === 200) {
          const resp = await res.json();
          const modules = (resp.data || []).filter(m => m.status === true).map(m => m.module_name);
          return modules;
        }
      } catch (e) {}
      return [];
    };

    const buildRerunConfig = (conversationIds, recordTypes) => {
      const cfg = {
        conversation_ids: conversationIds,
        processing_status: ['completed', 'error'],
        date_range: { start: '', end: '' }
      };
      if (recordTypes && recordTypes.length > 0) {
        cfg.record_type = recordTypes;
      } else {
        cfg.record_type = ['call','chat'];
      }
      return cfg;
    };

    const handleRerunAppsClick = async () => {
      try {
        if (isRerunPrechecking || isRerunApplying || loading) return;
        setIsRerunPrechecking(true);

        const timeline = (data && data.timeline) ? data.timeline : [];
        const calls = timeline.filter(item => item && (item.type === 'call' || item.type === 'chat'));
        const conversationIds = Array.from(new Set(calls.map(item => item.id))).filter(Boolean);
        if (conversationIds.length === 0) {
          showToast('No conversations found to rerun.', 'error');
          setIsRerunPrechecking(false);
          return;
        }

        const recordTypes = Array.from(new Set(calls.map(item => item.type))).filter(Boolean);
        const modules = await getEnabledModulesList();
        if (!modules || modules.length === 0) {
          showToast('No enabled apps to rerun. Enable apps in Apps Management.', 'error');
          setIsRerunPrechecking(false);
          return;
        }

        const config = buildRerunConfig(conversationIds, recordTypes);
        config.modules_list = modules;

        let resp = await server.checkConversationChanges(
          client_id,
          Array.isArray(service_id) ? service_id[0] : service_id,
          email,
          'apps',
          undefined,
          config
        );

        if (resp.status === 200) {
          const info = await resp.json();
          setRerunTotalCost(info.total_cost || 0);
          setRerunCurrentBalance(info.current_balance || 0);
          setRerunAffectedCount(info.total_count || 0);
          setRerunBalanceValid(info.valid || 0);
          setCanProceedRerun(((info.total_cost || 0) <= (info.current_balance || 0)) || info.valid === 1);
          setPendingRerunConfig(config);
          setShowRerunConfirm(true);
        } else {
          try {
            const err = await resp.json();
            showToast(err.error || 'Failed to pre-check changes.', 'error');
          } catch (_) {
            showToast('Failed to pre-check changes.', 'error');
          }
        }
      } catch (error) {
        showToast('Failed to pre-check changes.', 'error');
      } finally {
        setIsRerunPrechecking(false);
      }
    };

    const handleRerunApply = async () => {
      try {
        if (!pendingRerunConfig) return;
        setIsRerunApplying(true);
        let res = await server.applyConversationChanges({
          client_id,
          service_id: Array.isArray(service_id) ? service_id[0] : service_id,
          email,
          menu: 'apps',
          submenu: undefined,
          configuration: pendingRerunConfig
        });
        if (res.status === 200) {
          showToast('Modules are being processed. You will be notified once the changes are applied.', 'success');
          setShowRerunConfirm(false);
          setPendingRerunConfig(null);
        } else {
          try {
            const err = await res.json();
            showToast(err.error || 'Failed to apply changes.', 'error');
          } catch (_) {
            showToast('Failed to apply changes.', 'error');
          }
        }
      } catch (error) {
        showToast('Failed to apply changes.', 'error');
      } finally {
        setIsRerunApplying(false);
      }
    };

    const handleCloseRerunConfirm = () => {
      if (isRerunApplying) return;
      setShowRerunConfirm(false);
    };
    return (
        <div style={{ padding: '0 1rem', width: "100%", height: (window.location.href.includes('?token=')) ? window.innerHeight : window.innerHeight - 66.5, overflowY: "auto" }} className="bg-gray-50">
            {
                    !loading && !showConversationPage && (
                      <>
                      {!window.location.href.includes('?token=') && <div className="flex justify-between items-center">
                        <button onClick={handleGoBack} style={{display: 'flex',alignItems: 'center',color: '#4b5563',cursor: 'pointer',border: 'none',background: 'none',padding: '8px',fontSize: '14px',}}>
                        <MdArrowBack style={{ marginRight: '8px' }} />
                        Back
                      </button>
                      <div style={{display: 'flex', alignItems: 'center'}}>
                        <button onClick={handleHardRefresh} disabled={loading} className="flex items-center px-4 py-1 my-1 ml-1" style={{fontSize: '14px', color: loading ? '#9ca3af' : '#4b5563'}}>
                          <IoRefresh/>
                          <span className="ml-1">{loading ? 'Refreshing...' : 'Refresh'}</span>
                        </button>
                        <div style={{ position: 'relative' }} className="ml-1">
                          <button onClick={() => setShowActionsMenu(prev => !prev)} disabled={isRerunPrechecking || isRerunApplying || loading} className="flex items-center px-2 py-1 my-1" style={{fontSize: '14px', color: (isRerunPrechecking || isRerunApplying || loading) ? '#9ca3af' : '#4b5563'}}>
                            <MoreVertical size={18} />
                          </button>
                          {showActionsMenu && (
                            <div style={{ position: 'absolute', right: 0, top: '100%', marginTop: '6px', background: 'white', border: '1px solid rgb(229,231,235)', borderRadius: '6px', boxShadow: '0 4px 10px rgba(0,0,0,0.08)', zIndex: 1000000000, minWidth: '200px' }}>
                              <div onClick={() => { setShowActionsMenu(false); handleRerunAppsClick(); }} style={{ padding: '8px 12px', fontSize: '14px', cursor: 'pointer' }} className="hover:bg-gray-50">Rerun Customer</div>
                            </div>
                          )}
                        </div>
                      </div>
                      </div>}
                    {
                      showRerunConfirm && (
                        <div style={{ position: "fixed", height: "100%", width: "100%", top: 0, left: 0, zIndex: 9999999999, background: "rgba(0, 0, 0, 0.5)" }}>
                          <div style={{ position: "fixed", top: "25%", left: (window.innerWidth>760) ? "32%":"3.5%", width: (window.innerWidth>760) ? "36%":"93%", background: "white", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)", padding: "16px", zIndex: 10000000000 }}>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                              <h3 className="text-xl" style={{fontWeight: 600, color: '#111827'}}>Confirm Rerun</h3>
                              <button onClick={handleCloseRerunConfirm} className="text-gray-500 hover:text-gray-700"><FaTimes style={{color: 'slategray'}}/></button>
                            </div>
                            <div style={{marginTop: '12px', fontSize: '14px', color: '#374151'}}>
                              <div>Apply to {rerunAffectedCount} conversations</div>
                              <div style={{marginTop: '6px', color: '#6b7280'}}>Est. Credits: {Math.round(rerunTotalCost, 2) || '-'} | Current Balance: {Math.round(rerunCurrentBalance, 2) || '-'}</div>
                              {rerunTotalCost > rerunCurrentBalance && rerunBalanceValid === 0 && (
                                <div style={{marginTop: '6px', color: '#ef4444'}}>Insufficient Credits. Please recharge or reduce selection.</div>
                              )}
                            </div>
                            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px'}}>
                              <button onClick={handleCloseRerunConfirm} className="px-4 py-2 border border-gray-300 rounded text-gray-700 text-base">Cancel</button>
                              <button onClick={handleRerunApply} disabled={!canProceedRerun || isRerunApplying} className="px-4 py-2 rounded text-white font-medium text-base disabled:opacity-50 disabled:cursor-not-allowed" style={{ backgroundColor: 'rgb(79 70 229)' }}>{isRerunApplying ? 'Applying...' : 'Proceed'}</button>
                            </div>
                          </div>
                        </div>
                      )
                    }
                      {
                        !data ? (
                          <>
                          <div className="flex justify-center items-center" style={{ height: "100%", flexDirection: "column" }}>
                                    <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                                    <h2 style={{textAlign: "center", fontSize: "24px"}}>No Customers Details Found.</h2>
                                </div>
                          </>
                        ) : (
                            <div style={{display: "flex", height: (window.location.href.includes('?token=')) ? "100%" : "auto"}}>
                                <div style={{flex: "0.65", overflowY: "auto", background: "white", borderRadius: "10px 10px 0 6px"}} className='shadow-sm'>
                                  {/* Tab Row: single horizontal, scrollable, no wrap */}
                                  <div style={{position: 'relative', width: '100%'}}>
                                    {/* Left Arrow */}
                                    {canScrollLeft && (
                                      <button
                                        onClick={() => scrollTabRow('left')}
                                        style={{
                                          position: 'absolute',
                                          left: 0,
                                          top: 0,
                                          bottom: 0,
                                          zIndex: 1000000000,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'flex-start',
                                          background: 'white',
                                          border: 'none',
                                          cursor: 'pointer',
                                          height: '97%',
                                          padding: 0,
                                          outline: 'none',
                                          transition: 'background 0.2s',
                                          pointerEvents: 'auto'
                                        }}
                                        aria-label="Scroll left"
                                      >
                                        <ChevronsLeft size={20} color="#808080" />
                                      </button>
                                    )}
                                    {/* Right Arrow */}
                                    {canScrollRight && (
                                      <button
                                        onClick={() => scrollTabRow('right')}
                                        style={{
                                          position: 'absolute',
                                          right: 0,
                                          top: 0,
                                          bottom: 0,
                                          zIndex: 1000000000,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'flex-end',
                                          background: 'white',
                                          border: 'none',
                                          cursor: 'pointer',
                                          height: '97%',
                                          padding: 0,
                                          outline: 'none',
                                          transition: 'background 0.2s',
                                          pointerEvents: 'auto'
                                        }}
                                        aria-label="Scroll right"
                                      >
                                        <ChevronsRight size={20} color="#808080" />
                                      </button>
                                    )}
                                    <div
                                      ref={tabRowRef}
                                      style={{
                                        display: "flex",
                                        overflowX: "auto",
                                        overflowY: "hidden",
                                        whiteSpace: "nowrap",
                                        alignItems: "center",
                                        padding: "0 4px",
                                        gap: "8px",
                                        borderRadius: "6px 0 0 0",
                                        borderBottom: "1.5px solid #e3e3e3",
                                        background: "white",
                                        scrollbarWidth: "none", // Firefox
                                        msOverflowStyle: "none", // IE/Edge
                                      }}
                                      className="custom-tab-scrollbar"
                                    >
                                      {filteredSections.map((section, idx) => (
                                        <div
                                          key={section.title}
                                          className={`sections-headings${expandedSection === idx ? " expanded" : ""}`}
                                          onClick={() => toggleSection(idx)}
                                          style={{
                                            minWidth: "120px",
                                            maxWidth: "320px",
                                            width: "auto",
                                            flex: "none",
                                            margin: "0 2px",
                                            padding: "10px",
                                            borderRadius: "10px 10px 0 0",
                                            borderBottom: expandedSection === idx ? "3.5px solid #6f6ffe" : "2px solid transparent",
                                            marginBottom: expandedSection === idx ? "-1.5px" : "0",
                                            zIndex: 1,
                                            background: expandedSection === idx ? "white" : "rgba(255,255,255,0.28)",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                            fontWeight: expandedSection === idx ? 500 : 400,
                                            color: expandedSection === idx ? "#6f6ffe" : "#222",
                                            fontSize: "15px",
                                            justifyContent: "flex-start"
                                          }}
                                          title={section.title}
                                        >
                                          {renderIconHere(section.title)}
                                          <span style={{
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            display: "inline-block",
                                            maxWidth: "220px"
                                          }}>{section.title}</span>
                                        </div>
                                      ))}
                                    </div>
                                    {/* Hide scrollbar with CSS */}
                                    <style>{`
                                      .custom-tab-scrollbar {
                                        scrollbar-width: none;
                                      }
                                      .custom-tab-scrollbar::-webkit-scrollbar {
                                        display: none;
                                      }
                                    `}</style>
                                  </div>
                                  {/* Section Content: only show selected section */}
                                  <div style={{marginTop: "10px"}}>
                                    {selectedSection && (
                                      <FeedbackSection
                                        key={selectedSection?.dataKey}
                                        dataKey={selectedSection?.dataKey}
                                        data={selectedSection?.data}
                                        metadata={selectedSection?.metadata}
                                        toggleShowMore={toggleShowMore}
                                        showMoreMap={showMoreMap}
                                        source_click={handleSourceClick}
                                      />
                                    )}
                                  </div>
                                </div>
                                <div style={{flex: "0.35"}}>
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <div style={{display: "flex", flexDirection: "column", background: "white", borderRadius: "10px 10px 6px 0px", marginLeft: "10px", height: (!window.location.href.includes('?token=')) ? "87vh" : "100vh"}}>
                                            <div style={{display: "flex", alignItems: "center", fontSize: "16px", fontWeight: "500", padding: "0.5rem 0", paddingLeft: "0.5rem", borderBottom: "1px solid rgb(214, 214, 214)", borderRadius: "10px 10px 0 0", height: "46px" }}><RiMapPinTimeLine style={{marginRight: "10px"}}/>Timeline</div>
                                            <div style={{overflowY: "auto"}}>
                                                {
                                                    data.timeline && data.timeline.length > 0 && (
                                                        <div className="timeline">
                                                            <div className="timeline-line" />
                                                            {data.timeline.sort((a, b) => new Date(a.time) - new Date(b.time)).map((item, index) => (
                                                                <div key={index} className={`feedback-item call`}>
                                                                    <div className={`status-indicator call`}>
                                                                        {item.type === 'call' && <IoIosCall className="text-indigo-600"/>}
                                                                        {item.type === 'chat' && <IoChatbubbleOutline className="text-indigo-600"/>}
                                                                        {item.type === 'trigger' && <IoFlashOutline className="text-indigo-600"/>}
                                                                        {item.type === 'event' && <IoPulseOutline className="text-indigo-600"/>}
                                                                    </div>
                                                                    <div style={{padding: "7px", marginLeft: "2rem", borderRadius:"6px", marginTop: "10px", background: "#ffffff47", marginRight: "10px", marginBottom: "10px"}} className={`${item.type} border`}>
                                                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                                            <div style={{fontSize: "9px"}}>
                                                                              <span style={{ padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.type}</span>
                                                                              {item.type !== 'trigger' && item.type !== 'event' && (
                                                                                <>
                                                                                  <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.employee_id}</span>
                                                                                  {item.outcome && <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.outcome}</span>}
                                                                                  {item.conversation_direction && <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.conversation_direction}</span>}
                                                                                  {item.conversation_type && <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.conversation_type}</span>}
                                                                                </>
                                                                              )}
                                                                              {item.type === 'trigger' && (
                                                                                <>
                                                                                  {item?.trigger_data?.trigger_type && (
                                                                                    <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)", textTransform: 'capitalize'}}>
                                                                                      {String(item?.trigger_data?.trigger_type).replaceAll('_',' ')}
                                                                                    </span>
                                                                                  )}
                                                                                </>
                                                                              )}
                                                                              {item.type === 'event' && (
                                                                                <>
                                                                                  {item.event_name && <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.event_name}</span>}
                                                                                  {item.event_status && <span style={{marginLeft: "0.2rem", padding: "4px 4px", borderRadius: "10px", background: "rgba(218, 220, 224, 0.46)"}}>{item.event_status}</span>}
                                                                                </>
                                                                              )}
                                                                            </div>
                                                                            <div style={{color: "grey", fontSize: "12px"}}>
                                                                                {convertEpochToReadable(item, false)}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "6px", marginLeft: "8px"}}>
                                                                            <div style={{fontSize: "14px"}}>
                                                                              {item.type === 'trigger' ? (item.trigger_id || item.id) : item.id}
                                                                            </div>
                                                                            <div style={{display: "flex", alignItems: "center"}}>
                                                                              {item.type !== 'trigger' && item.type !== 'event' && (
                                                                                <div onClick={() => toggleSummary(index)}>
                                                                                  {
                                                                                    showSummary[index] ? <IoIosCloseCircleOutline style={{marginRight: "10px", cursor: "pointer"}}/> : <FaEye style={{marginRight: "10px", cursor: "pointer"}}/>
                                                                                  }
                                                                                </div>
                                                                              )}
                                                                              {(item.type === 'trigger' || item.type === 'event') ? (
                                                                                <div onClick={() => openTriggerModal(item)} className="view-details-btn">View Details</div>
                                                                              ) : (
                                                                                <div onClick={() => gotoCalls(item.id)} className="view-details-btn">View Details</div>
                                                                              )}
                                                                            </div>
                                                                        </div>
                                                                        {item.type !== 'trigger' && item.type !== 'event' && (
                                                                          showSummary[index] && (
                                                                              <>
                                                                                  <hr style={{margin:"5px"}}/>
                                                                                  <div style={{fontSize: "14px"}}>
                                                                                      <div>Summary: </div>
                                                                                      <div style={{color: "#5d6467", fontWeight: "500"}}>
                                                                                          {item.summary_short ? item.summary_short : item.summary}
                                                                                      </div>
                                                                                  </div>
                                                                              </>
                                                                          )
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        }
                    </>)}
                    {
                        loading && !showConversationPage && (
                            <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                <div className="loader"></div>
                                <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                            </div>
                        )
                    }
                    {
                      showConversationPage && (
                        <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999", padding: "5px"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{setShowConversationPage(false); setSelectedSegment(null); setSelectedTab(null); setSelectedCallID(null);}}><FaTimes style={{color: "slategray"}}/></div>
                            <div style={{overflow: "auto", height: "100%"}}>
                              <CallDetails selectedOption={service_id} open_type={handleClose} callIdProp={selectedCallID} selectedClientId={client_id} selectedSegment={selectedSegment} selectedTab={selectedTab}/>
                            </div>
                        </div>
                        </div>
                      )
                    }
                    {showTriggerModal && selectedTrigger && (
                      <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "9999999999"}}>
                        <div style={{position: "fixed", left: "10%", top: "8%", width: "80%", height: "84%", background: "white", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", padding: "10px"}}>
                          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e5e7eb', paddingBottom: '8px'}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                              {selectedTrigger.type === 'event' ? <IoPulseOutline className="text-indigo-600" /> : <IoFlashOutline className="text-indigo-600" />}
                              <div style={{fontSize: '16px', fontWeight: 600}}>{selectedTrigger.type === 'event' ? 'Event Details' : 'Trigger Details'}</div>
                            </div>
                            <FaTimes className="cursor-pointer" onClick={closeTriggerModal} />
                          </div>
                          {selectedTrigger.type === 'event' ? (
                          <div style={{marginTop: '10px', height: 'calc(100% - 40px)', overflow: 'auto'}}>
                            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px', fontSize: '14px'}}>
                              {[
                                ['Event Name', selectedTrigger.event_name],
                                ['Event Status', selectedTrigger.event_status],
                                ['Event Time', selectedTrigger.time ? convertEpochToReadable({time: selectedTrigger.time}, false) : null],
                                ['Event ID', selectedTrigger.event_id],
                                ['Event Reference ID', selectedTrigger.id],
                                ['Processing Status', selectedTrigger.processing_status],
                              ].map(([label, value]) => (
                                <div key={label} style={{display: 'flex', flexDirection: 'column'}}>
                                  <div style={{fontSize: '13px', color: 'darkslategray'}}>{label}</div>
                                  <div style={{fontSize: '15px', wordBreak: 'break-all'}}>{value ?? 'N/A'}</div>
                                </div>
                              ))}
                            </div>
                            <div style={{fontWeight: 600, marginBottom: '6px'}}>Fields Sent With Event</div>
                            <pre style={{whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px', lineHeight: '1.4', background: '#f9fafb', padding: '10px', borderRadius: '6px', border: '1px solid #e5e7eb'}}>
                              {JSON.stringify(selectedTrigger.event_data || {}, null, 2)}
                            </pre>
                          </div>
                          ) : (
                          <div style={{marginTop: '10px', height: 'calc(100% - 40px)', overflow: 'auto'}}>
                            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px', fontSize: '14px'}}>
                              <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{fontSize: '13px', color: 'darkslategray'}}>Trigger ID</div>
                                <div style={{fontSize: '15px', wordBreak: 'break-all'}}>{selectedTrigger?.trigger_id || selectedTrigger?.id}</div>
                              </div>
                              <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{fontSize: '13px', color: 'darkslategray'}}>Trigger Type</div>
                                <div style={{fontSize: '15px'}}>{String(selectedTrigger?.trigger_data?.trigger_type || 'N/A')}</div>
                              </div>
                              <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{fontSize: '13px', color: 'darkslategray'}}>Trigger Time</div>
                                <div style={{fontSize: '15px'}}>{selectedTrigger?.trigger_data?.trigger_time ? convertEpochToReadable({time: selectedTrigger.trigger_data.trigger_time}, false) : 'N/A'}</div>
                              </div>
                              <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{fontSize: '13px', color: 'darkslategray'}}>Event Time</div>
                                <div style={{fontSize: '15px'}}>{selectedTrigger?.trigger_data?.trigger_event_time ? convertEpochToReadable({time: selectedTrigger.trigger_data.trigger_event_time}, false) : 'N/A'}</div>
                              </div>
                            </div>
                            <div style={{fontWeight: 600, marginBottom: '6px'}}>Raw Trigger Data</div>
                            <pre style={{whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px', lineHeight: '1.4', background: '#f9fafb', padding: '10px', borderRadius: '6px', border: '1px solid #e5e7eb'}}>
                              {JSON.stringify(selectedTrigger?.trigger_data || {}, null, 2)}
                            </pre>
                          </div>
                          )}
                        </div>
                      </div>
                    )}
                    <style jsx>
                        {`
                            .timeline {
                                position: relative;
                            }

                            .timeline-line {
                                position: absolute;
                                left: 1rem;
                                top: 0;
                                bottom: 0;
                                width: 2px;
                                background-color: #e5e7eb;
                            }
                            .status-indicator {
                                position: absolute;
                                left: 0.25rem;
                                width: 1.5rem;
                                height: 1.5rem;
                                border-radius: 50%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.875rem;
                                margin-top: 24px;
                            }

                            .status-indicator.call {
                                background-color: white;
                                color: black;
                            }

                            .status-indicator.ticket {
                                background-color: #fefce8;
                                color: #a16207;
                            }
                            .view-details-btn {
                                transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
                                border: 1px solid rgb(209 213 217);
                                width: 90px;
                                font-size: 12px;
                                text-align: center;
                                padding: 3px;
                                border-radius: 6px;
                                cursor: pointer;
                                background: white;
                            }

                            .view-details-btn:hover {
                                background: rgb(249, 250, 251);
                            }
                            .sections-headings {
                            cursor: pointer;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 10px;
                            background: rgba(255, 255, 255, 0.28);
                            border-radius: 10px;
                            transition: background 0.3s;
                            }

                            .sections-headings.expanded {
                            border-bottom: 1px solid rgb(227, 227, 227);
                            border-radius: 10px 10px 0 0;
                            }

                            .sections-headings:hover {
                            background: rgb(249, 250, 251);
                            }

                            .section-title {
                            font-size: 15px;
                            font-weight: 500;
                            display: flex;
                            align-items: center;
                            }

                        `}
                    </style>
        </div>
    )
}

export default CustomerDetails;
